export function OnsiteComment(lbNoteComment) {
    var self = this;
    this.id = lbNoteComment.id;
    this.noteId = lbNoteComment.noteId;
    this.created = moment(lbNoteComment.created).toDate();
    this.comment = lbNoteComment.comment;
    this.createdBy = lbNoteComment.createdBy.firstName + " " + lbNoteComment.createdBy.lastName;
    this.siteCode = null;
    this.siteName = null;
    this.userName = null;
    this.templateValues = lbNoteComment.templateValues;

    function lowerFieldName(field) {
        return field.charAt(0).toLowerCase() + field.slice(1);
    }

    if(lbNoteComment.templateValues) {
        lbNoteComment.templateValues.forEach(function (value) {
            var templateSegName = lowerFieldName(value.templateSegmentName);

            self[templateSegName] = (templateSegName === "timeIn" || templateSegName === "timeOut")
                ? moment(value.value).toDate()
                : value.value;
        });
    }
};